import { createDenormalizedSelector } from 'entities/selectors'
import { serviceSchema, ticketsSchema } from 'wordpress/schemas'

/* Services */

const serviceIdSelector = (state, props) => props.serviceId
export const serviceSelector = createDenormalizedSelector(serviceIdSelector, serviceSchema)

/* Offers */

const ticketIdSelector = (state, props) => props.ticketId
export const ticketSelector = createDenormalizedSelector(ticketIdSelector, ticketsSchema)
